import React, { useState } from "react";

import Context from "../../../../../../context";
import values from "../../../../../../values";
import {
  CustomButton2,
  CustomModal,
  CustomView,
} from "../../../../../../components";
import "./index.scss";
import { useTranslation } from "react-i18next";

const Approve = ({
  role,
}: {
  role: "ADMIN" | "SUPER_AGENT_SCHOOL" | "COMPANY";
}) => {
  const {
    showModal,
    setShowModal,
    isLoading,
    selectedWithdrawal,
    withdrawalUpdateOne,
  } = React.useContext(Context.WithdrawalScreen);

  const [textArea, setTextArea] = useState<string>("");

  const { t } = useTranslation();

  return (
    <section id="school-approve-modal-container">
      <CustomModal onClose={() => setShowModal!("NONE")} open={showModal === "SEND_2_BANK"}>
        <CustomView.Container className="approve-form-content">
          <CustomView.Row className="form-row">
            <CustomView.Column>
              <CustomView.Column medium={8} className="form-colum dropdown description-input">
                <div><label className="form-label">{t("description")}</label></div>
                <textarea cols={33} rows={3} onChange={(e) => setTextArea(e.target.value)}>{textArea}</textarea>
              </CustomView.Column>
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="form-row">
            <CustomView.Column large={3} medium={4} small={6} className="form-colum">
              <CustomButton2
                isLoading={isLoading}
                onClick={() => {
                  withdrawalUpdateOne({
                    type: 'SEND_2_BANK',
                    _id: selectedWithdrawal?._id,
                    description: textArea,
                  });
                  setShowModal!("NONE");
                }}
                title='ارسال به بانک'
                type="primary"
              />
            </CustomView.Column>
            <CustomView.Column>{}</CustomView.Column>
          </CustomView.Row>
        </CustomView.Container>
      </CustomModal>
    </section>
  );
};

export default Approve;
